'use client'
import { FC } from 'react'

import { useSelector } from 'shared-redux'

import { useSlideOut } from '#/src/custom/controllers'
import MoreFilters from 'storefront-modules/products/components/product-list-vertical/MoreFilters'
import { selectedProductState } from 'shared-redux/state'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

export interface ISlideOutMoreFilters1 {}

const SlideOutMoreFilters1: FC<ISlideOutMoreFilters1> = () => {
  const productsState = useSelector(selectedProductState)
  const { closeSlideOut } = useSlideOut()
  const appConfig = useAppConfig()

  return (
    <MoreFilters
      onSearchUpdate={closeSlideOut}
      pt={12}
      sliderDefaultValues={appConfig.sliderDefaultValues}
      sliderMaxPrice={appConfig.sliderMaxPrice}
      sortingOptions={appConfig.sortingOptions}
      {...{ productsState }}
    />
  )
}

export default SlideOutMoreFilters1
